import { ToolboxItem } from '../../canvas/tooling/ToolboxItem';
import { markerTool } from './MarkerTool';
import { MarkerWidget } from './MarkerWidget';

export const markerToolboxItem = ToolboxItem({
    id: 'markerTool',
    label: 'Marker',
    ui: MarkerWidget,
    keepOpen: true,
    weight: 1070,
    tools: [markerTool],
});
